module.exports = __webpack_public_path__ + "static/media/pool.a3feec3d.jpg";